/* QBand · Mockup de celular com vídeo (snippets/qband-phone-mockup.liquid).
   window.qbMockupInit(el) liga um mockup e devolve { play, pause }.
   Pode ser chamado de novo para mockups clonados de <template>. */
(() => {
  if (window.qbMockupInit) return;

  window.qbMockupInit = (root) => {
    if (!root) return null;
    if (root.qbMockup) return root.qbMockup;
    const video = root.querySelector('video');
    const toggle = root.querySelector('[data-qb-mockup-toggle]');
    video.muted = true; // a propriedade precisa estar ligada para o autoplay funcionar
    let userPaused = false;

    const sync = () => {
      const playing = !video.paused;
      root.classList.toggle('is-playing', playing);
      toggle.setAttribute('aria-pressed', String(playing));
    };
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);

    const api = {
      play(fromUser = false) {
        if (userPaused && !fromUser) return Promise.resolve();
        if (fromUser) userPaused = false;
        if (!video.src) video.src = video.dataset.src;
        return video.play().catch(() => {});
      },
      pause(fromUser = false) {
        if (fromUser) userPaused = true;
        video.pause();
      },
    };

    toggle.addEventListener('click', () => (video.paused ? api.play(true) : api.pause(true)));
    root.qbMockup = api;
    return api;
  };

  document.querySelectorAll('[data-qb-mockup-root]').forEach((el) => window.qbMockupInit(el));
  document.dispatchEvent(new CustomEvent('qb:mockup-ready'));
})();
